import { Box, Form, Grid, Select, Text, TextField } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { constants } from 'modules/common';
import { memo } from 'react';

import { messages } from './FinancialDetailsPart.messages';
import { FinancialDetailsPartProps } from './FinancialDetailsPart.types';

const qa = 'financial-details';

export const FinancialDetailsPart = memo<FinancialDetailsPartProps>((props) => {
    const { isUKCompany, currencies } = props;

    return (
        <Form.Part>
            <div>
                <Box spacing='16 0'>
                    <Text color='midnight80' font='headline' fontSize='xxsmall' fontWeight='medium'>
                        {messages.currencyTitle}
                    </Text>
                </Box>

                <Grid gridTemplateColumns='1fr 1fr' columnGap={16}>
                    <Select
                        name='defaultCurrency'
                        label={messages.baseCurrency}
                        placeholder={messages.baseCurrencyPlaceholder}
                        items={currencies}
                        itemNameKey='text'
                        autocomplete
                        qa={domHelpers.generateDataQa(qa, 'default-currency-editor')}
                    />
                </Grid>
            </div>

            <div>
                <Box spacing='16 0'>
                    <Text color='midnight80' font='headline' fontSize='xxsmall' fontWeight='medium'>
                        {messages.batchPaymentTitle}
                    </Text>
                </Box>

                <Grid gridTemplateColumns='1fr 1fr' columnGap={16}>
                    {isUKCompany && (
                        <TextField
                            name='bankAccount.sortCode'
                            label={messages.sortCode}
                            placeholder={messages.sortCodePlaceholder}
                            maxLength={constants.xeroConstants.sortCodeMaxLength}
                            deps={['bankAccount.accountNumber']}
                            qa={domHelpers.generateDataQa(qa, 'sort-code-editor')}
                        />
                    )}

                    <TextField
                        name='bankAccount.accountNumber'
                        label={messages.bankAccountNumber}
                        placeholder={messages.bankAccountNumberPlaceholder}
                        maxLength={constants.xeroConstants.BANK_ACCOUNT_DETAILS_MAX_LENGTH}
                        qa={domHelpers.generateDataQa(qa, 'bank-account-number-editor')}
                    />
                </Grid>
            </div>
        </Form.Part>
    );
});

FinancialDetailsPart.displayName = 'FinancialDetailsPart';
